import React from 'react';
import styled from 'styled-components/macro';

import { Fader } from 'src/client/components/ui/Fader';
import { LineBehind } from 'src/client/components/ui/LineBehind';

type Testimonial = {
  UUID: string;
  title: string;
  quote: string;
  name: string;
};

type Props = {
  className?: string;
  content: Testimonial[];
  show?: boolean;
};

export const Testimonials = (props: Props) => {
  const { className = '', content, show = true } = props;

  if (!show) return null;

  return (
    <StyledTestimonials className={`${className} testimonials`}>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <LineBehind label="TESTIMONIALS" />
          </div>
        </div>
        <Fader itemsToShow={3} speed={5000}>
          {content.map((ttml) => (
            <div className="col-md-4" key={ttml.UUID}>
              <Quote>
                <QuoteLarge>
                  <BeginQuote>&quot;</BeginQuote>
                  {ttml.title}
                </QuoteLarge>
                <Paragraph>
                  {ttml.quote}
                  <EndQuote>&quot;</EndQuote>
                </Paragraph>
                <QuoteFooter>- {ttml.name}</QuoteFooter>
              </Quote>
            </div>
          ))}
        </Fader>
      </div>
    </StyledTestimonials>
  );
};

const StyledTestimonials = styled.section`
  background-color: ${(props) => props.theme.splashOptional1};
`;

const Quote = styled.div`
  text-transform: uppercase;
  font-size: 0.85rem;
  margin: 0 10px;

  @media (max-width: 991px) {
    margin: 0 10px 20px 20px;
  }
`;

const QuoteLarge = styled.span`
  font-weight: 700;
  font-size: 2.6rem;
  line-height: 30px;

  @media (max-width: 1199px) {
    font-size: 1.43rem;
    line-height: 26px;
  }

  @media (max-width: 767px) {
    font-size: 1.6rem;
    line-height: 25px;
  }

  @media (max-width: 639px) {
    font-size: 1.43rem;
    line-height: 20px;
    font-weight: 500;
  }
  color: ${(props) => props.theme.footerBarPrimary3};
`;

const Paragraph = styled.p`
  color: ${(props) => props.theme.footerBarPrimary2};
`;

const BeginQuote = styled.span`
  font-style: italic;
  font-weight: 700;
  display: inline-block;
  position: absolute;
  padding-right: 1em;
  font-size: 2.6rem;
  margin-left: -27px;
  color: ${(props) => props.theme.footerBarPrimary3};
`;

const EndQuote = styled.span`
  font-style: italic;
  font-weight: 700;
  display: inline-block;
  position: absolute;
  padding-right: 1em;
  font-size: 2.15rem;
  line-height: 23px;
  margin-left: 5px;
  margin-top: 1px;
  color: ${(props) => props.theme.footerBarPrimary3};
`;

const QuoteFooter = styled.div`
  font-weight: 700;
  padding-top: 10px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.footerBarPrimary2};
`;
